<template>
    <div id="login-component" class="d-flex flex-column justify-content-center align-items-center pt-5">

        <div>
            <button data-toggle="modal" data-target="#login-modal" id="toggleLoginModal"
                    class="py-1 px-3 px-lg-5 loginButton mt-3 mt-lg-5"
                    @click="showModal()">
                Acces Cadeți
            </button>
        </div>

        <div id="myProfile" class="myProfileButton">
            <router-link
                    to="/profile">
                Profilul Meu
            </router-link>
        </div>

        <login-modal v-show="loginModalClicked"
                     @codeScanned="onCodeScanned"></login-modal>

    </div>
</template>

<script>
    import LoginModal from './LoginModal'
    import * as uuid from 'uuid';
    import Swal from 'sweetalert2';

    const axios = require('axios');

    const Toast = Swal.mixin({
        toast: true,
        position: 'top',
        showConfirmButton: false,
        timer: 3000
    });

    export default {
        name: "Login",
        components: {
            LoginModal
        },
        data() {
            return {
                loginModalClicked: false,
            }
        },
        mounted(){
            const $ = window.$;

            $('#login-modal').on("hidden.bs.modal", function () {
                this.loginModalClicked = false;
                document.getElementById('toggler').setAttribute('aria-expanded', false);
            });

            $('.modal').on('hidden.bs.modal', function () {
                this.loginModalClicked = false;
                document.getElementById('toggler').setAttribute('aria-expanded', false);
            });

            $('#app').click(function () {
                this.loginModalClicked = false;
                document.getElementById('toggler').setAttribute('aria-expanded', false);
            });

            if (this.$cookie.get('access-token') && this.$cookie.get('access-token') !== '') {
                $('#toggleLoginModal').addClass('d-none');
                $('.loginButton').removeClass('d-block').addClass('d-none');
                $('#myProfile').addClass('d-block');
                $('.myProfileButton').removeClass('d-none').addClass('d-block');
            } else {
                $('#myProfile').addClass('d-none');
                $('.myProfileButton').removeClass('d-block').addClass('d-none');
                $('#toggleLoginModal').addClass('d-block');
                $('.loginButton').removeClass('d-none').addClass('d-block');
            }
        },
        methods: {
            onCodeScanned(code) {
                const $ = window.$;
                let baseUrl = this.$cookie.get('base-url');
                let loginUrl = baseUrl + 'api/auth/login';
                let self = this;
                const kidTerminal = uuid.v4();
                let headers = {};
                if (this.$cookie.get('terminal-uid')) {
                    headers = {'terminal-uid': this.$cookie.get('terminal-uid')};
                } else {
                    headers = {'terminal-uid': kidTerminal};
                }

                axios.post(loginUrl, {code: code}, {headers})
                    .then(function (response) {

                        $('#toggleLoginModal').click();
                        self.loginModalClicked = false;

                        self.$cookie.set('access-token', response.data.result.token_type + ' ' + response.data.result.access_token, 1);
                        self.$cookie.set('terminal-uid', kidTerminal, 1);

                        self.$store.commit('setUser', response.data.result.user);
                        self.$router.push('profile');

                        if (self.$cookie.get('access-token') && self.$cookie.get('access-token') !== '') {
                            $('.loginButton').addClass('d-none');
                            $('.myProfileButton').addClass('d-block')
                        } else {
                            $('.loginButton').addClass('d-none');
                            $('.myProfileButton').addClass('d-none')
                        }

                        Toast.fire({
                            type: 'error',
                            title: 'Cardul a fost scanat cu succes!',
                            animation: true,
                            customClass: {
                                popup: 'animated tada'
                            }
                        });
                    })
                    .catch(function (error) {
                        console.log(error);

                        Toast.fire({
                            type: 'error',
                            title: 'Cardul nu este valid!',
                            animation: true,
                            customClass: {
                                popup: 'animated tada'
                            }
                        });
                    });
            },
            showModal() {
                const $ = window.$;
                this.loginModalClicked = !this.loginModalClicked;
                $('#navbarToggler').removeClass('show');
            },
        }
    }
</script>

<style scoped>

</style>